// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import type { QuickstartEventHandler, State } from '../../../services/types.tsx';

export const setEventHandler =
	(onEvent: QuickstartEventHandler | null): Action<State> =>
	async ({ setState }) => {
		setState({ onEvent });
	};
